import { Box } from "@mui/material";
import { v2, nums } from "../ui/v2Tokens";
import { Card } from "../ui/primitives";
import type { MealShare } from "./dayComposition";

type Props = {
  shares: MealShare[];
  /** the trainee reported this day — see the caption below */
  logged: boolean;
};

/**
 * What the day was made of, by meal.
 *
 * The one thing a day's macro totals cannot show: two trainees can hit the same calories with a
 * breakfast-heavy day and an evening-heavy one, and only one of them is the conversation the
 * trainer wants to have.
 */
const DayCompositionCard = ({ shares, logged }: Props) => {
  if (shares.length === 0) return null;

  return (
    <Card data-testid="day-composition" sx={{ padding: "13px 16px" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "baseline",
          gap: "8px",
          flexWrap: "wrap",
          marginBottom: "9px",
        }}
      >
        <Box sx={{ fontSize: "12.5px", fontWeight: 700, color: v2.ink2 }}>מה הרכיב את היום</Box>
        {/* On an unreported day these are the PLAN's proportions, not the trainee's — the same
            honesty the assigned-menu card above keeps, in the one other place it could mislead. */}
        {!logged && (
          <Box sx={{ fontSize: "11px", color: v2.ink4 }}>
            לפי התפריט שהוקצה — המתאמן לא דיווח
          </Box>
        )}
      </Box>

      <Box
        aria-hidden
        sx={{ display: "flex", height: 13, borderRadius: "99px", overflow: "hidden", background: v2.lineSoft }}
      >
        {shares.map((share) => (
          <Box key={share.uid} sx={{ width: `${share.pct}%`, background: share.color }} />
        ))}
      </Box>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "6px 16px", marginTop: "10px" }}>
        {shares.map((share) => (
          <Box
            key={share.uid}
            sx={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "12px", color: v2.ink2 }}
          >
            <Box sx={{ width: 9, height: 9, borderRadius: "3px", background: share.color, flex: "none" }} />
            {share.name}
            <Box component="span" sx={{ fontWeight: 700, color: v2.ink, ...nums }}>
              {share.pct}%
            </Box>
          </Box>
        ))}
      </Box>
    </Card>
  );
};

export default DayCompositionCard;
